// Source credits, set on each layer both as `customProperties.info.credit` (layer info popup) and as
// `extraArcgisParameter.copyright` (map attribution bar). Wording agreed in D2208-482 (Esri Living Atlas: D2208-484).
export const LAYER_ATTRIBUTIONS = {
  usfsFireLab: 'US Forest Service Fire Lab',
  gadm: 'GADM',
  esriLivingAtlas: 'Esri Living Atlas, NASA',
  nasa: 'NASA',
  conservationSciencePartners: 'Conservation Science Partners',
  oakRidgeNationalLaboratory: 'Oak Ridge National Laboratory',
  esaCopernicus: 'ESA, Copernicus'
} as const
